import { addDoc, collection, doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export async function createConsentDocument(docData) {
  const col = collection(db, 'artifacts', appId, 'public', 'data', 'documents');
  const consentDocRef = await addDoc(col, docData);
  return consentDocRef.id;
}

export async function linkConsentToPetition(petitionDocId, consentDocId) {
  const petRef = doc(db, 'artifacts', appId, 'public', 'data', 'documents', petitionDocId);
  await updateDoc(petRef, {
    consentDocumentId: consentDocId,
    updatedAt: serverTimestamp(),
  });
}

export async function logConsentToClientNotes(clientId, consentName, petitionTitle, consentDocId, petitionDocId, actorName) {
  const notesRef = collection(db, 'artifacts', appId, 'public', 'data', 'clients', clientId, 'notes');
  await addDoc(notesRef, {
    category: 'SYSTEM',
    type: 'DOCUMENT_CONSENT_REQUESTED',
    payload: {
      text: `Consentimento informado publicado: ${consentName}`,
      html: `<p><strong>Consentimento informado publicado:</strong> ${consentName}</p><p>Vinculado à petição: ${petitionTitle || '—'}</p>`,
      documentId: consentDocId,
      parentDocumentId: petitionDocId,
      title: consentName,
      module: 'consent_builder',
      requiresConsent: true,
    },
    actor: { name: actorName, isBot: false },
    createdAt: serverTimestamp(),
  });
}
